import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";
import getToken from "../services/tokenService";
import { useState } from "react";
import { useEffect } from "react";

const dataFormatter = new Jsona();

const repositoryApiService = async (resource = "libraries", options = {}) => {
  const baseUrl = `${visionURL}/repository/api/v1`;
  options = { ...options, ...{ baseUrl } };
  const service = new JsonApiService(resource, options);
  const token = await getToken();
  return service.setAuthToken(token);
};

export const useRepositories = () => {
  const [repositories, setRepositories] = useState([]);
  const [isLoading, setIsLoading] = useState([]);

  useEffect(() => {
    const getRepositories = async () => {
      setIsLoading(true);
      const service = await repositoryApiService();
      const response = await service
        .include("customer")
        .all()
        .then(response => {
          return response.json();
        });
      const repositories = dataFormatter.deserialize(response);
      setIsLoading(false);
      setRepositories(repositories);
      return response;
    };

    getRepositories();
  }, []);
  return { repositories, isLoading };
};
